import wesleyPic from "@/public/images/artists/wesley.jpg";
import { Artist } from "@/types/types";

export const wesley = {
  id: "286",
  name: "Wesley",
  image: wesleyPic,
  description: `Wesley has a warm, textured voice with a slight grain and controlled power.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fwesley-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Soul", "Ballads"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 48,
        high: 71,
      },
      sweetSpot: 60,
    },
  },
} satisfies Artist;
